export const legacyTypes = {
  LIST_LEGACY: 'LIST_LEGACY_JOB',
  LIST_LEGACY_SUCCESS: 'LIST_LEGACY_ITEM_JOB_SUCCESS',
  LIST_LEGACY_FAIL: 'LIST_LEGACY_ITEM_JOB_FAIL',
};
